import { Button } from 'antd';
import { useState } from 'react';
import { useAbortTrip } from '../hooks/use-abort-trip';
import { AbortModal } from './AbortModal';

interface AbortTripButtonProps {
  tripId: string;
  onAborted: () => void;
  /** `link` is the board's row action; `button` is the trip page's. */
  variant?: 'button' | 'link';
}

/** The Abort action and the form it opens, for one trip. The caller decides whether to render it (`canOfferAbort`). */
export function AbortTripButton({ tripId, onAborted, variant = 'button' }: AbortTripButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { abort, isSubmitting, error, clearError } = useAbortTrip(tripId, onAborted);

  async function submit(values: Parameters<typeof abort>[0]): Promise<boolean> {
    const done = await abort(values);
    if (done) setIsOpen(false);
    return done;
  }
  function close() {
    clearError();
    setIsOpen(false);
  }

  return (
    <>
      <Button danger type={variant === 'link' ? 'link' : 'default'} size={variant === 'link' ? 'small' : 'middle'} onClick={() => setIsOpen(true)}>
        {variant === 'link' ? 'Abort' : 'Abort trip'}
      </Button>
      <AbortModal open={isOpen} submitting={isSubmitting} error={error} onSubmit={submit} onCancel={close} />
    </>
  );
}
